export const breweries = [
  {
    id: 1,
    name: 'Half Acre Beer Company',
    location: 'Chicago, IL',
    featuredBeer: '"Midnight Oil" Oatmeal Stout',
    episode: 'EP. 12 – Ford F-150 Carb Rebuild',
    episodeUrl: '#',
    mapEmbedQuery: 'Half+Acre+Beer+Company+Chicago',
    rating: 5,
    notes: 'The stout that got me through a three-day carburetor job. Dense, chocolatey, deserved.',
  },
  {
    id: 2,
    name: 'Dogfish Head Craft Brewery',
    location: 'Milton, DE',
    featuredBeer: '90 Minute IPA',
    episode: 'EP. 08 – Replacing Truck Leaf Springs',
    episodeUrl: '#',
    mapEmbedQuery: 'Dogfish+Head+Brewery+Milton+Delaware',
    rating: 5,
    notes: 'Bold enough for when you\'ve stripped three bolts in a row. Balanced enough to keep going.',
  },
  {
    id: 3,
    name: 'Bell\'s Brewery',
    location: 'Kalamazoo, MI',
    featuredBeer: 'Two Hearted Ale',
    episode: 'EP. 15 – Welding Cracked Exhaust Manifold',
    episodeUrl: '#',
    mapEmbedQuery: 'Bells+Brewery+Kalamazoo+Michigan',
    rating: 5,
    notes: 'Crisp, hoppy, and so consistent it\'s basically a torque spec. Cannot go wrong.',
  },
  {
    id: 4,
    name: 'Oskar Blues Brewery',
    location: 'Longmont, CO',
    featuredBeer: 'Dale\'s Pale Ale',
    episode: 'EP. 03 – Honda CB750 Engine Rebuild',
    episodeUrl: '#',
    mapEmbedQuery: 'Oskar+Blues+Brewery+Longmont+Colorado',
    rating: 4,
    notes: 'In a can. For the garage. As it should be. Classic.',
  },
  {
    id: 5,
    name: 'Tröegs Independent Brewing',
    location: 'Hershey, PA',
    featuredBeer: 'Nugget Nectar',
    episode: 'EP. 19 – Stuck Brake Caliper Fix',
    episodeUrl: '#',
    mapEmbedQuery: 'Troegs+Brewing+Hershey+Pennsylvania',
    rating: 5,
    notes: 'Seasonal. Earn it. Only drink it after something actually hard.',
  },
];
